export default __webpack_public_path__ + "static/media/image-upload.6d816a0e.png";